/* eslint-disable */
// TODO: conver to functional component
import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import { connect } from "react-redux";

import Component from "components/component";

import Currency from "./currency";
import QuantityCounter from "./quantity-counter";
import VariationImage from "./variation-image";
import {
  formatUpchargeAmount,
  getCoordinatesRelativeToDocument,
  getDisplayPriceOfSizeSelection,
  isSizeOption,
  stripZeros,
} from "lib/helpers";
import mapDispatchToProps from "lib/map-dispatch-to-props";
import * as modalActions from "actions/modals";
import { calculateEstimatedTotal } from 'selectors/configurator-selectors';

const COM_DISPLAY_NAME = "COM";
const COL_DISPLAY_NAME = "COL";

class SummaryDesktop extends Component {
  static propTypes = {
    customRequest: PropTypes.string,
    decreaseQuantity: PropTypes.func.isRequired,
    depth: PropTypes.string,
    estimatedTotalPrice: PropTypes.number,
    height: PropTypes.string,
    increaseQuantity: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    product: ImmutablePropTypes.map,
    variationImageURL: PropTypes.string,
    persistVariationImageURL: PropTypes.bool.isRequired,
    quantityCount: PropTypes.number.isRequired,
    selections: ImmutablePropTypes.map,
    width: PropTypes.string,
    updateURL: PropTypes.func.isRequired,
    hasVariationImages: PropTypes.bool.isRequired,
    selectedVariant: ImmutablePropTypes.map,
    comRequiredYardage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    userId: PropTypes.string,
    userRole: PropTypes.string,
    tradeAccessPending: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      fixed: false,
      elWidth: "auto",
      top: 0
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.adjustFixedStatus, false);
    window.addEventListener("resize", this.adjustWidth, false);

    this.adjustFixedStatus();
    this.adjustWidth();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.adjustFixedStatus, false);
    window.removeEventListener("resize", this.adjustWidth, false);
  }

  openLogin = e => {
    e.preventDefault();
    this.props.actions.modalActions.openModal("login");
  };

  isCustom = () => {
    return this.props.sectionalLayoutIsCustom || this.props.sideADimension || this.props.sideBDimension || this.props.sideCDimension;
  }

  openTradeAccessPending = e => {
    e.preventDefault();
    this.props.actions.modalActions.openModal("trade-access-pending");
  };

  getLeadTime() {
    const { defaultLeadTime } = gon;
    const { selections, quantityCount } = this.props;
    let leadTime = defaultLeadTime;

    selections.valueSeq().forEach((selection, key) => {
      const { name } = selection.toObject();

      if (['fabric_col', 'specialty_com'].includes(name)) {
        leadTime = '12-14 Weeks';
      }
    });

    return leadTime;
  }

  render() {
    const { fixed, elWidth, top } = this.state;
    const {
      customRequest,
      decreaseQuantity,
      estimatedTotalPrice,
      openModal,
      increaseQuantity,
      variationImageURL,
      persistVariationImageURL,
      quantityCount,
      product,
      updateURL,
      comRequiredYardage,
      selectedVariant,
      selections,
      userId,
      userRole,
      tradeAccessPending
    } = this.props;

    const { defaultLeadTime } = gon;
    const isCustom = this.isCustom();

    const hasLengthOption =
      LENGTH_PRODUCT_TYPES.indexOf(this.props.product.get("productType")) > -1;

    const sizeSelection = selections.find(ov => {
      return SIZE_OPTION_NAMES.indexOf(ov.get("optionType")) > -1;
    });


    let listPrice = selectedVariant.get('listPrice');
    // Old way; can we remove this?
    // let totalListPrice = listPrice * quantityCount / 100.0;
    let totalListPrice = calculateEstimatedTotal(listPrice, selections);

    let classSet = "product-quote-panel";

    if (fixed) classSet += " fixed";

    return (
      <div className="col-4-12 configurator-summary desktop-only">
        <div className={classSet} style={{ width: elWidth, top: top }}>
          <div className="product-quote-image">
            <VariationImage
              src={variationImageURL}
              openModal={openModal}
              imgixParams={{ w: 500, h: 281.25 }}
              initialSrc={product.get("primaryImageUrl")}
              updateURL={updateURL}
              hasError={!persistVariationImageURL}
              hasVariationImages={this.props.hasVariationImages}
            />
          </div>

          <div className="product-quote-price">
            <div className="product-quote-price-cell product-quote-price-cell-left">
              <p className="quote-title">{isCustom ? '' : 'Est. Total'}</p>
            </div>

            <div className="product-quote-price-cell product-quote-price-cell-right">
              <p className="price-text">
                <span className="price">
                  {isCustom ? (
                    <span style={{ textTransform: 'none' }}>Request Price</span>
                  ) : (
                    <Currency price={totalListPrice} />
                  )}
                </span>
              </p>
              {userId ? (
                <>
                  {userRole === 'retail_user' ? (
                    <>
                      {tradeAccessPending ? (
                        <p className="price-text">
                          <a
                            onClick={this.openTradeAccessPending}
                            className="large right signup-button"
                          >
                            View Net Pricing
                          </a>
                        </p>
                      ) : (
                        <p className="price-text">
                          <a
                            onClick={this.openLogin}
                            className="large right signup-button"
                          >
                            View Net Pricing
                          </a>
                        </p>
                      )
                      }
                    </>
                  ) : (
                    <>
                      {!isCustom && (
                        <p className="price-text">
                          Net Price
                          <span className="price">
                            <Currency price={estimatedTotalPrice} />
                          </span>
                        </p>
                      )}
                    </>
                  )
                  }
                </>
              ) : (
                <p className="price-text">
                  <a
                    onClick={this.openLogin}
                    className="large right signup-button"
                  >
                    View Net Pricing
                  </a>
                </p>
              )
              }
            </div>
          </div>

          <div className="product-quote-details">
            <div className="product-quote-row">
              <div className="product-quote-row-cell">
                <span className="quote-details-title">Quantity</span>
              </div>

              <QuantityCounter
                quantityCount={quantityCount}
                increaseQuantity={increaseQuantity}
                decreaseQuantity={decreaseQuantity}
              />
            </div>

            {product.get("productType") === "beds" &&
              this.renderBedSizeSelection()}

            {!isCustom && this.renderSizeSelections(hasLengthOption)}

            {!isCustom && (
              <div className="product-quote-row">
                <div className="product-quote-row-cell com-required-yardage">
                  <p className="quote-details-title">COM Required Yardage</p>
                  <span className="product-detail-customization">
                    {comRequiredYardage}{" "}
                    {quantityCount > 1 ? ` × ${quantityCount}` : ""}
                  </span>
                </div>
              </div>
            )}

            {this.displaySelections(isCustom)}

            {defaultLeadTime && (
              <div className="product-quote-row">
                <div className="product-quote-row-cell com-required-yardage">
                  <p className="quote-details-title">Lead Time</p>
                  <span className="product-detail-customization">
                    {this.getLeadTime()}
                  </span>
                </div>
              </div>
            )}

            {userRole === 'trade_user' &&
              <div className="product-quote-row">
                <div className="product-quote-row-cell custom-request">
                  <p className="quote-details-title">Custom Request</p>
                  <p className={classnames({
                    "quote-details-value": true,
                    "no-custom-request": !customRequest,
                  })}>
                    {customRequest ? customRequest : 'None specified'}
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  renderBedSizeSelection = () => {
    const { selections } = this.props;
    const bedSizeOption = selections
      .find(ov => {
        return ov.get("optionType") === "Bed Frame Size";
      })
      .toObject();

    return (
      <div className="product-quote-row">
        <div className="product-quote-row-cell">
          <span className="quote-details-title">
            {bedSizeOption.optionType}
          </span>
          <span className="product-detail-customization">
            {bedSizeOption.displayName}
          </span>
        </div>

        <div className="product-quote-row-cell" />
      </div>
    );
  };

  renderSizeSelections = hasLengthOption => {
    const {
      height,
      width,
      depth,
      selections,
      product,
      selectedVariant,
      quantityCount,
      userId,
      userRole
    } = this.props;
    const customDimensions = product.getIn(["master", "customDimensions"]);
    const sizeSelection = selections.find(ov => {
      return SIZE_OPTION_NAMES.indexOf(ov.get("optionType")) > -1;
    });

    let displayPrice = getDisplayPriceOfSizeSelection(
      sizeSelection,
      selectedVariant
    );

    if (quantityCount > 1) {
      displayPrice += ` × ${quantityCount}`;
    }

    let listPrice = selectedVariant.get('displayListPrice');
    if (quantityCount > 1) {
      listPrice += ` × ${quantityCount}`;
    }

    return (
      <div className="product-quote-row">
        <div className="product-quote-row-cell">
          <span className="quote-details-title">Size</span>
          {customDimensions && (
            <span
              className="product-detail-customization"
              dangerouslySetInnerHTML={{ __html: customDimensions }}
            />
          )}

          {!customDimensions &&
            !hasLengthOption && (
              <span className="product-detail-customization">
                W {formatDimension(width)} / D {formatDimension(depth)} / H{" "}
                {formatDimension(height)}
              </span>
            )}

          {!customDimensions &&
            hasLengthOption && (
              <span className="product-detail-customization">
                W {formatDimension(width)} / L {formatDimension(depth)} / H{" "}
                {formatDimension(height)}
              </span>
            )}
        </div>

        <div className="product-quote-row-cell">
          {(userId && userRole === 'trade_user') ? (
            <p className="option-value-price">
              {displayPrice}
            </p>
          ) : (
            <p className="option-value-price">
              {listPrice}
            </p>
          )
          }
        </div>
      </div>
    );
  };

  displaySelections = (isCustom) => {
    const { selections, quantityCount } = this.props;

    return selections.valueSeq().map((selection, key) => {
      const { displayName, optionType, upchargeAmount } = selection.toObject();

      let displayUpchargeAmount = selection.get("displayUpchargeAmount");

      if (isSizeOption(optionType)) return null;
      if (optionType === "Bed Frame Size") return null;

      if (optionType === "Fabric" && upchargeAmount > 0) {
        displayUpchargeAmount = `$${(upchargeAmount / 100.0).toString()}`;
      }

      return (
        <div className="product-quote-row" key={key}>
          <div className="product-quote-row-cell">
            <span className="quote-details-title">{optionType}</span>
            <span className="product-detail-customization">{displayName}</span>
          </div>

          <div className="product-quote-row-cell">
            {!isCustom && displayName !== COM_DISPLAY_NAME &&
              displayName !== COL_DISPLAY_NAME && (
                <p className="option-value-price">
                  {formatUpchargeAmount(displayUpchargeAmount)}{" "}
                  {formatQuantitySuffix(quantityCount, displayUpchargeAmount)}
                </p>
              )}
            {!isCustom && displayName === COM_DISPLAY_NAME && (
              <p className="option-value-price">+$0</p>
            )}
            {!isCustom && displayName === COL_DISPLAY_NAME && (
              <p className="option-value-price">
                +${upchargeAmount / 100} {formatQuantitySuffix(quantityCount)}
              </p>
            )}
          </div>
        </div>
      );
    });
  };

  adjustFixedStatus = () => {
    const scrollHeight =
      document.body.scrollTop || document.documentElement.scrollTop;
    const quotePanel = document.getElementsByClassName(
      "product-quote-panel"
    )[0];
    const quotePanelHeight = quotePanel.clientHeight;
    const hasGeneralCustomizationNotice =
      SHOW_CUSTOMIZATION_NOTE &&
      GENERAL_CUSTOMIZATION_NOTICE_PRODUCT_TYPES.indexOf(
        this.props.product.get("productType")
      ) > -1;
    const fixed = this.state.fixed;

    let configurator;
    let firstOptionRow;

    if (hasGeneralCustomizationNotice) {
      configurator = document.getElementById("customization-notice");
      firstOptionRow = document.getElementsByClassName("product-options")[0];
    } else {
      configurator = document.getElementsByClassName("product-options")[0];
    }

    const configuratorTop = getCoordinatesRelativeToDocument(configurator).top;

    if (scrollHeight >= configuratorTop) {
      const quotePanelBottom =
        getCoordinatesRelativeToDocument(quotePanel).top + quotePanelHeight;

      // If there is a warning notice, use the first option row to determine bottom scroll limits
      // or else the element will never receive fixed positioning
      const configuratorBottom = hasGeneralCustomizationNotice
        ? getCoordinatesRelativeToDocument(firstOptionRow).top +
        firstOptionRow.clientHeight
        : configuratorTop + configurator.clientHeight;
      const quotePanelConfiguratorBottomDifference =
        quotePanelBottom - configuratorBottom;

      if (
        fixed &&
        quotePanelConfiguratorBottomDifference > 0 &&
        hasGeneralCustomizationNotice
      ) {
        this.setState({
          // Add 54 at the end to acount for margin added for customization note
          top:
            firstOptionRow.clientHeight -
            quotePanelHeight +
            configurator.clientHeight +
            54,
          fixed: false
        });

        return;
      } else if (fixed && quotePanelConfiguratorBottomDifference > 0) {
        this.setState({
          top: configurator.clientHeight - quotePanelHeight,
          fixed: false
        });

        return;
      }

      if (scrollHeight <= configuratorBottom - quotePanelHeight) {
        this.setState({
          fixed: true,
          elWidth: calculateWidth(),
          top: 0
        });
      }
    } else if (scrollHeight < configuratorTop) {
      if (fixed) {
        this.setState({
          elWidth: "auto",
          fixed: false,
          top: 0
        });
      }
    }
  };

  adjustWidth = () => {
    const scrollHeight = document.body.scrollTop;
    const configuratorTop = getCoordinatesRelativeToDocument(containerElement())
      .top;
    let state = { elWidth: calculateWidth() };

    // Reset the fixed status if necessary
    // (ex. if we've resized from desktop -> mobile -> desktop)
    if (scrollHeight < configuratorTop) state.fixed = false;

    this.setState(state);
  };
}

function formatDimension(dimension) {
  return dimension ? `${stripZeros(dimension)}"` : "-";
}

function containerElement() {
  return document.getElementById("configurator-container");
}

function subcontainerElement() {
  return document.getElementsByClassName("product-customize-options")[0];
}

function calculateWidth() {
  // Summary width is 31.25% of the configurator container
  return getElementContentWidth(subcontainerElement()) * 0.32;
}

function getElementContentWidth(element) {
  var styles = window.getComputedStyle(element);
  var padding = parseFloat(styles.paddingLeft) +
    parseFloat(styles.paddingRight);

  return element.clientWidth - padding;
}

function formatQuantitySuffix(quantity, displayUpchargeAmount = "") {
  if (displayUpchargeAmount === "$0") {
    return "";
  }

  return quantity > 1 ? `× ${quantity}` : "";
}

function mapStateToProps(state) {
  const { userId, userRole, tradeAccessPending } = state.userStore.toObject();
  return {
    userId,
    userRole,
    tradeAccessPending
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps(modalActions)
)(SummaryDesktop);
